import { render, staticRenderFns } from "./GoEasyVideoPlayer.vue?vue&type=template&id=d1a68ac2&scoped=true"
import script from "./GoEasyVideoPlayer.vue?vue&type=script&lang=js"
export * from "./GoEasyVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./GoEasyVideoPlayer.vue?vue&type=style&index=0&id=d1a68ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a68ac2",
  null
  
)

export default component.exports